<div class="text-center" style="margin-bottom: 20px">
  <h2>{{ headerTitle() }}</h2>
  <p>{{ headerSubtitle() }}</p>
</div>
<div class="content-modal">
  <div class="survey-question">
    <p class="survey-title">1. {{ zoneModuleLabel() }}</p>
    <div class="survey-options">
      @for (opt of formData.modules[0].options; track opt.value) {
        <label class="survey-option">
          <input
            type="radio"
            name="zone_type"
            [checked]="prefSelectedZone === opt.value"
            (change)="onZoneOptionChange(opt)"
          />
          {{ zoneOptionLabel(opt) }}
        </label>
        @if (opt.input && prefSelectedZone === opt.value) {
          <input
            class="form-control pref-input"
            type="text"
            [placeholder]="zoneInputPlaceholder(opt)"
            [ngModel]="prefZones"
            (ngModelChange)="prefZonesChange.emit($event)"
          />
        }
      }
    </div>
  </div>

  <div class="survey-question">
    <p class="survey-title">2. {{ ticketSectionTitle() }}</p>
    <div class="ticket-inputs">
      @for (
        g of formData.ticketModules.selectGroup;
        track g.label;
        let idx = $index
      ) {
        <div class="input-inv">
          <label>{{ selectGroupLabel(g) }}</label>
          <div class="group-select">
            <div class="custom-select">
              <div class="select-value">
                <span>{{
                  (idx === 0
                    ? getSelectedMinTicket()
                    : getSelectedMaxTicket()) || ticketPlaceholder(g)
                }}</span>
                <mat-icon>expand_more</mat-icon>
              </div>
              @if (idx === 0) {
                <mat-select
                  [value]="prefMinTicket"
                  (selectionChange)="onTicketChange($event, 'desde')"
                  panelClass="custom-select-panel"
                  disableOptionCentering
                >
                  @for (option of arrayTicketMin; track option.value) {
                    <mat-option
                      [value]="option.value"
                      [disabled]="option.isDisabled"
                    >
                      {{ option.name }}
                    </mat-option>
                  }
                </mat-select>
              } @else {
                <mat-select
                  [value]="prefMaxTicket"
                  (selectionChange)="onTicketChange($event, 'hasta')"
                  panelClass="custom-select-panel"
                  disableOptionCentering
                >
                  @for (option of arrayTicketMax; track option.value) {
                    <mat-option
                      [value]="option.value"
                      [disabled]="option.isDisabled"
                    >
                      {{ option.name }}
                    </mat-option>
                  }
                </mat-select>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="survey-question">
    <p class="survey-title">3. {{ assetModuleLabel() }}</p>
    <div class="survey-options grid-2">
      @for (
        opt of formData.modulesMultiple[0].options;
        track opt.value;
        let i = $index
      ) {
        <label class="survey-option">
          <input
            type="checkbox"
            [checked]="prefAssetTypes.includes(assetToggleKey(i))"
            (change)="toggleAssetType.emit(assetToggleKey(i))"
          />
          {{ assetOptionLabel(opt) }}
        </label>
      }
    </div>
  </div>

  <div class="survey-question">
    <p class="survey-title">4. {{ propertiesTitle() }}</p>
    <div class="survey-options grid-2">
      @for (opt of formData.modulesOptions.options; track opt.value) {
        <label class="survey-option">
          <input
            type="radio"
            name="properties"
            [checked]="prefPropertiesCount === opt.value"
            (change)="prefPropertiesCountChange.emit(opt.value)"
          />
          {{ propertyOptionLabel(opt) }}
        </label>
      }
    </div>
    <label class="survey-option" style="margin-top: 10px">
      <input
        type="checkbox"
        [ngModel]="prefProblematic"
        (ngModelChange)="prefProblematicChange.emit($event)"
      />
      {{ problematicLabel() }}
    </label>
  </div>

  <button
    id="btn_signin_submit"
    type="button"
    (click)="submit.emit()"
    [disabled]="!registerForm?.valid || !preferencesStepComplete() || isLoading"
    class="submit-btn"
  >
    <span *ngIf="!isLoading">{{ buttonLabel() }}</span>
    <mat-progress-spinner
      *ngIf="isLoading"
      mode="indeterminate"
      color="primary"
      [diameter]="20"
    ></mat-progress-spinner>
  </button>
</div>
